import { apiSlice } from '../../api/apiSlice';

export const dashboardHeaderApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserId: builder.mutation({
      query: () => ({
        url: 'Dashboard/GetUserId',
        method: 'GET',
        credentials: 'include'
      })
    }),
    setUserIdStatus: builder.mutation({
      query: (option) => ({
        url: `Dashboard/SetUserIdStatus/${option.show}`,
        method: 'POST',
        credentials: 'include',
      })
    }),
    getCRMUrl: builder.mutation({
      query: () => ({
        url: 'Dashboard/GetCRMUrl',
        method: 'GET',
        credentials: 'include'
      })
    }),
    GetSchoolDistrictInfo: builder.mutation({
      query: () => ({
        url: 'Dashboard/GetSchoolDistrictInfo',
        method: 'GET',
        credentials: 'include'
      })
    })
  })
});

export const { 
  useGetUserIdMutation,
  useSetUserIdStatusMutation,
  useGetCRMUrlMutation,
  useGetSchoolDistrictInfoMutation
} = dashboardHeaderApi;
